<script setup lang="ts">
type props = {
  size?: 'small' | 'medium' | 'large'
}

const props = withDefaults(defineProps<props>(), {
  size: 'medium'
})
</script>

<template>
  <span
    class="wrapper"
    :style="
      props.size === 'small' ? '--width: 1.5rem;' : props.size === 'medium' ? '--width: 1.875rem' : '--width: 2.25rem'
    "
  >
    <span class="bar b1"></span>
    <span class="bar b2"></span>
    <span class="bar b3"></span>
    <span class="bar b4"></span>
    <span class="bar b5"></span>
  </span>
</template>

<style scoped>
.wrapper {
  margin-right: 0.5rem;
  min-width: var(--width);
  --width: 1.875rem;
  --height: calc(var(--width) * 2 / 3);
  height: var(--height);
  --minBarHeight: 10%;
  --duration: 1800ms;
  display: flex;
  gap: calc(var(--width) / 15);
  align-items: center;
}

.bar {
  border-radius: 2px;
  flex-grow: 1;
  background-color: currentColor;
}

.bar {
  animation: expand infinite;
  animation-duration: var(--duration);
}

.b1 {
  animation-delay: 0ms;
}

.b2 {
  animation-delay: calc(var(--duration) / 8);
}

.b3 {
  animation-delay: calc(var(--duration) / 8 * 2);
}

.b4 {
  animation-delay: calc(var(--duration) / 8 * 3);
}

.b5 {
  animation-delay: calc(var(--duration) / 8 * 4);
}

@keyframes expand {
  0% {
    height: var(--minBarHeight);
  }
  50% {
    height: 100%;
  }
  100% {
    height: var(--minBarHeight);
  }
}
</style>
